module.exports = __webpack_public_path__ + "static/Q2_2022_Investor_call_Dial-in-information-9da0b7a50825656cb9dada8f8e5b197e.pdf";